module.exports = __webpack_public_path__ + "img/2 (1).06bc87c4.png";